import { render } from "./AmenitiesPicker.vue?vue&type=template&id=3635f9c7"
import script from "./AmenitiesPicker.vue?vue&type=script&lang=js"
export * from "./AmenitiesPicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__